import { createWithEqualityFn } from 'zustand/traditional';

type AuthStoreState = {
  status?: 'in' | 'out' | 'loading' | null;
  uid: string | null;
};

const initialState: AuthStoreState = {
  status: 'loading',
  uid: null,
};

const useAuthStore = createWithEqualityFn<AuthStoreState>(() => initialState);

export default useAuthStore;
